import { AnySchema } from 'yup';

import Yup from '@tmh-website/services/validation.service';

import { ETContactFormValues } from './ETContactForm.contracts';

export const INITIAL_VALUES: ETContactFormValues = {
  email: '',
  firstName: '',
  gRecaptchaResponse: '',
  issueType: '',
  lastName: '',
  message: '',
  phone: '',
};

type ETContactFormValuesSchema = Record<keyof ETContactFormValues, AnySchema>;

export const validationSchema = Yup.object<ETContactFormValuesSchema>({
  email: Yup.string().email().required(),
  firstName: Yup.string().required(),
  gRecaptchaResponse: Yup.string().required(),
  issueType: Yup.string().required(),
  lastName: Yup.string().required(),
  message: Yup.string().required(),
  phone: Yup.string().matches(/^(|\+?[0-9 -]+)$/),
}).strict();
